import imageCompression from 'browser-image-compression';

/**
 * Compresses an image file using browser-image-compression.
 * @param {File} imageFile - The original image file.
 * @param {Object} customOptions - Custom options for compression.
 * @returns {Promise<File>} - The compressed image file.
 */
export const compressImage = async (imageFile, customOptions = {}) => {
  const options = {
    maxSizeMB: 2,           // Maximum size of the output image in MB
    maxWidthOrHeight: 1920, // Maximum width or height in pixels
    useWebWorker: true,    // Use web workers for performance
    initialQuality: 0.8,   // Initial quality of the compressed image
    ...customOptions
  };

  try {
    const compressedFile = await imageCompression(imageFile, options);
    console.log(`Original size: ${(imageFile.size / 1024 / 1024).toFixed(2)} MB`);
    console.log(`Compressed size: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`);

    // Retain the original name and type if possible
    return new File([compressedFile], imageFile.name, {
      type: compressedFile.type,
      lastModified: Date.now(),
    });
  } catch (error) {
    console.error('Image compression failed:', error);
    throw error;
  }
};
